import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xm};
`

export const Label = styled.span`
  font-family: ${theme.typography.family.primary};
  font-weight: ${theme.typography.weight.lg};
  font-size: ${theme.typography.sizes.xs};
  margin-bottom: ${theme.spacing.xs};
  color: ${theme.colors.neutral.high};
`
export const Content = styled.div`
  width: 100%;
  .MuiFormControlLabel-root {
    span.MuiTypography-root {
      font-family: ${theme.typography.family.bold};
      font-weight: ${theme.typography.weight.lg};
      color: #000000;
    }
  }
`
export const DescriptionWrapper = styled.div`
  width: 440px;
  max-width: 100%;
`
export const ContentDate = styled.div`
  display: flex;
  flex-direction: column;
`

export const InputDate = styled.input`
  padding: ${theme.spacing.sm};
  height: ${theme.spacing.xl};

  border: 1px solid ${theme.colors.neutral.mediumhover};
  border-radius: ${theme.shapes.borderRadius.sm};
  outline-color: ${theme.colors.primary.main};

  font-family: ${theme.typography.family.primary};
  font-weight: ${theme.typography.weight.xsm};
  font-size: ${theme.typography.sizes.sm};
  line-height: ${theme.typography.lineHeight.sm};
`
